module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-danurejan.24500ab6.png";